<script>
/**
 * Souls page - now uses SoulsPage component with composition API
 * This file serves as an alias for backward compatibility
 */
import SoulsPage from './SoulsPage.vue';
export default SoulsPage;
</script>
